import { FilterProcedureDataService } from './shared/filter-procedure.data.service';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { FilterProcedureConfig } from './shared/filter-procedure-config.service';
import { Base } from '@app/shared';


@Component({
  selector: 'iw-filter-procedure',
  templateUrl: './filter-procedure.component.html',
  styleUrls: ['./filter-procedure.component.scss'],
  providers: [FilterProcedureDataService]
})
export class FilterProcedureComponent implements OnInit, OnDestroy {
  // entrada de los trámites seleccionados del control
  @Input() set filterProcedures(procedures: number[]) {
    this._filterProcedures = procedures;
    if (this.filterProcedureList && this.filterProcedureList.length) {
      this.loadingProcedure();
    }
  }
   // Configuracion de la tabla
   settings = {};
   // Datos para llenar la tabla
   sourceData: LocalDataSource;
   // listado de todos los tramites
   // Lista de trámites asociados
   filterProcedureList: Base[];
   associatedProcedure: any[] = [];
   // Trámites asociados
  private _filterProcedures: number[] = [];
   // Retorna los documentos asociados del documento
  @Output() filters: EventEmitter<Array<any>> = new EventEmitter();

  constructor(private fpds: FilterProcedureDataService) { }

  ngOnInit() {
    // Configurando tabla
    const configTable = new FilterProcedureConfig();
    this.settings = configTable.settings;
    configTable.accion.subscribe((data: any) => {
      this.defineActions(data);
    });
    this.loadingProcedure();
    this.filters.emit(this.filterProcedures);
  }

  ngOnDestroy(){
    this.filters.emit(this.filterProcedures);
  }

  defineActions(data: any ) {
    switch (data.action) {
      case 'asociar':
        if (!this.filterProcedures.includes(data.row.id)) {
          this.filterProcedures.push(data.row.id);
          this.filters.emit(this.filterProcedures);
        }
        this.loadingProcedure(false);
      break;
      case 'eliminar':
        const index = this.filterProcedures.indexOf(data.row.id);
        if (index !== -1) {
          this.filterProcedures.splice(index, 1);
        }
        this.filters.emit(this.filterProcedures);
        this.loadingProcedure(false);
      break;
    }
  }

  get filterProcedures(): number[] {
    return this._filterProcedures;
  }

  /**
   * Carga los datos de la tabla
   *
   * @memberof ProcedureComponent
   */
  async loadingProcedure(refresh: boolean = true) {
    if (refresh) {
      this.filterProcedureList = await this.fpds.loadFilterProcedures();
    }
    if (this.filterProcedureList) {
      this.filterProcedureList.forEach(sourceD => {
        if (this.filterProcedures.length) {
          const index = this.filterProcedures.indexOf(sourceD.id);
          if (index !== -1) {
            sourceD['associate'] = 'Sí';
          } else {
            sourceD['associate'] = 'No';
          }
        } else {
          sourceD['associate'] = 'No';
        }
        sourceD['funtions'] = 'NoFuntions';
      });
      if (refresh) {
        this.sourceData = new LocalDataSource(this.filterProcedureList);
      }
    this.sourceData.refresh();
   }
    // this.procedureList.forEach(procedure=>{
    //   procedure['associate'] = 'No'
    // });
    // this.sourceData = new LocalDataSource(this.procedureList);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/filter-procedure/filter-procedure.component.ts